import {createSlice} from "@reduxjs/toolkit";
import moment from "moment";

export const newCashRegistersInitialValue = {
    name: '',
    date: new Date(),
    isSentToAade: 'inactive',
    serialNumber: '',
    notes: '',
    files: '',
    isActive: 'active',
    extra: '',
    accounting: "",
    bypassAccounting: "",
    accountingRunning: "",
}

export const newPOSInitialValue = {
    name: '',
    date: new Date(),
    isSentToAade: 'no',
    serialNumber: '',
    notes: '',
    files: '',
    isActive: 'active',
    extra: '',
    isETameiaki: 'inactive',
    tameiakiUsername: '',
    tameiakiPassword: '',
    tid: '',
    accounting: "",
    bypassAccounting: "",
    acquirer: "epay",
}

export const newBankAccountInitialValue = {
    name: '',
    date: new Date(),
    isSentToAade: 'no',
    iban: '',
    notes: '',
    files: '',
    bank: '',
    bankName: '',
    bankSwift: '',
    bankCountry: '',
    isActive: 'active',
    extra: '',
    accounting: "",
    bypassAccounting: "",
}

export const newChequeInitialValue = {
    type: 0,
    entityType: "client",
    numbering: "",
    entityId: "",
    entityName: "",
    amount: 0,
    issueDate: moment().toDate(),
    expiryDate: null,
    notes: "",

    used: false,
}

export const newCardInitialValue = {
    type: 0,
    name: "",
    numbering: "",
    isActive: "active",
    notes: "",
    accounting: "",
    bypassAccounting: "",
}

const newLoanInitialValue = {
    bank_institute: "",
    numbering: "",
    startDate: moment().toDate(),
    years: 5,
    principal: 0,
    interestRate: 3,
    isPaid: false,
    payments: [],
}

const initialCashSettings = {
    accounting: {
        accountingCashRegister: "",
        accountingPOS: "",
        accountingBankAccount: "",
    }
}

const initialState = {
    // Cash Registers
    newCashRegistersInitialValue: newCashRegistersInitialValue,
    newCashRegisters: newCashRegistersInitialValue,
    editCashRegisters: newCashRegistersInitialValue,
    cashRegisters: [],

    // POS
    newPOSInitialValue: newPOSInitialValue,
    newPOS: newPOSInitialValue,
    editPOS: newPOSInitialValue,
    posList: [],

    // Bank Account
    newBankAccountInitialValue: newBankAccountInitialValue,
    newBankAccount: newBankAccountInitialValue,
    editBankAccount: newBankAccountInitialValue,
    bankAccounts: [],

    // Cheque
    newCheque: newChequeInitialValue,
    editCheque: newChequeInitialValue,
    chequeList: [],

    // Loans
    newLoan: newLoanInitialValue,
    editLoan: newLoanInitialValue,

    // Cards
    newCard: newCardInitialValue,
    editCard: newCardInitialValue,
    cardList: [],

    // Search Data
    searchCashRegisters: [],
    searchPOS: [],
    searchBankAccounts: [],
    searchCheque: [],
    chequeSearchTotalItems: 0,
    searchLoans: [],
    loanSearchTotalItems: 0,
    searchCards: [],
    searchCardsTotalItems: 0,

    // Accounting Settings
    cashSettings: initialCashSettings,

    // Cheque Report
    chequeReportRequestData: {
        page: 1,
        numbering: "",
        type: "",
        status: "",
        entityName: "",
    },
    chequeReportResponseData: {
        data: [],
        totalPages: 0,
        totalItems: 0,
        totals: {
            totalRedeemed: 0,
            totalRedeemable: 0,
            totalExpired: 0,
            totalAmount: 0,
        },
    },

    // Loan Report
    loanReportRequestData: {
        page: 1,
        numbering: "",
    },
    loanReportResponseData: {
        data: [],
        totalPages: 0,
        totalItems: 0,
        totals: {
            principal: 0,
            remainingPrincipal: 0,
        },
    },
};

export const CashSlice = createSlice({
    name: "cash",
    initialState,
    reducers: {
        // Cash Registers
        setNewCashRegisters: (state, {payload}) => {
            state.newCashRegisters = payload;
        },
        setEditCashRegisters: (state, {payload}) => {
            state.editCashRegisters = payload;
        },

        // POS
        setNewPOS: (state, {payload}) => {
            state.newPOS = payload;
        },
        setEditPOS: (state, {payload}) => {
            state.editPOS = payload;
        },
        resetNewPOS: (state) => {
            state.newPOS = newPOSInitialValue;
        },

        // Bank Account
        setNewBankAccount: (state, {payload}) => {
            state.newBankAccount = payload;
        },
        setEditBankAccount: (state, {payload}) => {
            state.editBankAccount = payload;
        },
        resetNewBankAccount: (state) => {
            state.newBankAccount = {...newBankAccountInitialValue};
        },

        // Cheque
        setNewCheque: (state, {payload}) => {
            state.newCheque = payload;
        },
        setEditCheque: (state, {payload}) => {
            state.editCheque = payload;
        },
        resetNewCheque: (state) => {
            state.newCheque = newChequeInitialValue;
        },
        setChequeSearchData: (state, {payload}) => {
            state.chequeSearchData = payload;
        },
        setChequeSearchTotalItems: (state, {payload}) => {
            state.chequeSearchTotalItems = payload;
        },
        setChequeList: (state, {payload}) => {
            state.chequeList = payload;
        },

        // Loans
        setNewLoan: (state, {payload}) => {
            state.newLoan = payload;
        },
        setEditLoan: (state, {payload}) => {
            state.editLoan = payload;
        },
        resetNewLoan: (state) => {
            state.newLoan = newLoanInitialValue;
        },
        setLoansSearchData: (state, {payload}) => {
            state.searchLoans = payload;
        },
        setLoansSearchTotalItems: (state, {payload}) => {
            state.loanSearchTotalItems = payload;
        },

        // Cards
        setNewCard: (state, {payload}) => {
            state.newCard = payload;
        },
        setEditCard: (state, {payload}) => {
            state.editCard = payload;
        },
        resetNewCard: (state) => {
            state.newCard = {...newCardInitialValue};
        },
        setCardsSearchData: (state, {payload}) => {
            state.searchCards = payload;
        },
        setCardSearchTotalItems: (state, {payload}) => {
            state.searchCardsTotalItems = payload;
        },
        setCardList: (state, {payload}) => {
            state.cardList = payload;
        },

        // Search Data
        setSearchCashRegisters: (state, {payload}) => {
            state.searchCashRegisters = payload;
            state.cashRegisters = payload;
        },
        setSearchPOS: (state, {payload}) => {
            state.searchPOS = payload;
            state.posList = payload;
        },
        setSearchBankAccounts: (state, {payload}) => {
            state.searchBankAccounts = payload;
            state.bankAccounts = payload;
        },

        // Accounting Settings
        setCashSettings: (state, {payload}) => {
            state.cashSettings = payload;
        },
        setCashAccountingSettings: (state, {payload}) => {
            state.cashSettings.accounting = payload;
        },

        // Cheque Report
        setChequeReportRequestData: (state, {payload}) => {
            state.chequeReportRequestData = payload;
        },
        setChequeReportResponseData: (state, {payload}) => {
            state.chequeReportResponseData = payload;
        },

        // Loan Report
        setLoanReportRequestData: (state, {payload}) => {
            state.loanReportRequestData = payload;
        },
        setLoanReportResponseData: (state, {payload}) => {
            state.loanReportResponseData = payload;
        },
    },
});

export const {
    setNewCashRegisters,
    setEditCashRegisters,
    setNewPOS,
    setEditPOS,
    setNewBankAccount,
    setEditBankAccount,
    resetNewBankAccount,

    setNewCheque,
    setEditCheque,
    resetNewCheque,
    setChequeSearchData,
    setChequeSearchTotalItems,
    setChequeList,

    setNewLoan,
    setEditLoan,
    resetNewLoan,
    setLoansSearchData,
    setLoansSearchTotalItems,

    setLoanReportRequestData,
    setLoanReportResponseData,

    setNewCard,
    setEditCard,
    resetNewCard,
    setCardsSearchData,
    setCardSearchTotalItems,
    setCardList,

    setSearchCashRegisters,
    setSearchPOS,
    setSearchBankAccounts,
    resetNewPOS,
    setCashSettings,
    setCashAccountingSettings,

    setChequeReportRequestData,
    setChequeReportResponseData,
} = CashSlice.actions;